module.exports = __webpack_public_path__ + "static/media/paper_win.90d05824.png";